$(document).ready(function () {
    var video = $("[data-contentheader-video]"),
        toggle = $("[data-contentheader-video-toggle]");

    toggle.click(function () {
        videoToggle(toggle, video);
    });

    toggle.keypress(function (e) {
        // If enter.
        if (e.which == 13) {
            videoToggle();
        }
        // If space.
        if (e.which == 32) {
            videoToggle();
        }
    });
    if (video.length) {
        video[0].onended = function () {
            toggle.addClass("rerun");
            toggle.removeClass("play");
            toggle.removeClass("pause");
        }
    };
});

function videoToggle(toggle, video) {
    if (video.length) {
        if (video[0].paused) {
            video[0].play();
            toggle.addClass("pause");
            toggle.removeClass("play");
            toggle.removeClass("rerun");
        } else {
            video[0].pause();
            toggle.addClass("play");
            toggle.removeClass("pause");
            toggle.removeClass("rerun");
        }
    }
}
